import { useAuth } from "context/AuthContext";
import { useModal } from "context/ModalContext/Modal.context";
import { useEffect, useRef, useState } from "react";
import ModalWarning from "../ModalWarning";
import { useNavigate } from "react-router";
import "./style.scss";
import Button from "../Button/Button";
import { StageIds } from "utils/constants";

const UserNotifications = () => {
  const navigate = useNavigate();
  const {
    notifications,
    appCurrentStep,
    showNotifcation,
    setShowNotification,
    currentStep,
  } = useAuth();
  const { showModal, closeModal } = useModal();
  const [showList, setShowList] = useState(false);

  const notificationsRef = useRef<HTMLDivElement>(null);

  const handlerConfirm = (notification: any) => {
    console.log("currentstep", appCurrentStep);
    if (notifications && appCurrentStep?._id === StageIds.STAGE_INSCRICAO) {
      setShowList(false);
      navigate("/realizations/subscribe", {
        state: {
          data: notifications[0],
          notificationId: notifications[0]._id,
          action: "indication",
        },
      });
    } else {
      showModal(
        "subscribed",
        <ModalWarning
          title="Ops"
          description={
            <>
              <p>O período de confirmação de inscrição foi encerrado!</p>
            </>
          }
          btnText={"Fechar"}
          onBackButton={closeModal}
          onClose={closeModal}
        />,
        "is-subscribed"
      );
    }
  };

  useEffect(() => {
    console.log("total notification is", notifications.length);
    console.log("current step_realization", currentStep?.title);
    console.log(
      notifications.length > 0 && currentStep?._id === StageIds.STAGE_INSCRICAO
    );
    if (notifications.length > 0) {
      showModal(
        "notification",
        <ModalWarning
          title="Você possui uma iniciativa inscrita no Prêmio BB aguardando confirmação"
          description={
            <>
              <p className="mb-2 text-base">
                Você possui uma iniciativa inscrita no Prêmio BB: <br />
                <strong>{notifications[0].realization.title}</strong>
              </p>
              <p className="text-base">
                Para garantir sua participação na premiação, é necessário que
                você confirme a sua participação. Você será direcionado(a) para
                indicar até 5 funcionários (inclusive você próprio(a)), que
                poderão receber o prêmio individual, caso a iniciativa seja
                premiada na última etapa de avaliação.
              </p>
            </>
          }
          btnText={"Confirmar participação"}
          hasBackButton={true}
          backBtnText={"Cancelar"}
          onBackButton={closeModal}
          onClose={() => {
            closeModal();
            setShowNotification(false);
            setShowList(false);
            console.log({
              data: notifications[0],
              notificationId: notifications[0]._id,
              action: "indication",
            });
            navigate("/realizations/subscribe", {
              state: {
                data: notifications[0],
                notificationId: notifications[0]._id,
                action: "indication",
              },
            });
          }}
        />,
        "notification"
      );
    }
  }, [showNotifcation, notifications]);

  return (
    <>
      {showList && (
        <div
          ref={notificationsRef}
          className="py-4 rounded-lg bg-white-bb-1 notifications"
        >
          <h3 className="px-4 mb-4 text-base font-bold text-black-bb font-title">
            Notificações
          </h3>
          {notifications
            .filter((item) => item.type === "inscricao")
            .map((item: any, index: number) => (
              <div className="flex flex-col px-4 py-4 border-t border-b-black-bb ">
                <h3 className="mb-4 text-sm">{item.realization.title}</h3>
                <div className="flex justify-end">
                  <Button
                    next={() => {
                      handlerConfirm(item);
                    }}
                    text={"Confirmar"}
                  />
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  );
};

export default UserNotifications;
